import React, { useState } from "react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { CalendarDays, X } from "lucide-react";

export function toISODate(d) {
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
}

function fmt(d) {
  return d ? d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Kolkata" }) : "";
}

function startOfDay(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; }

function computePreset(key) {
  const today = startOfDay(new Date());
  if (key === "7") {
    const from = new Date(today); from.setDate(from.getDate() - 6);
    return { from, to: today };
  }
  if (key === "30") {
    const from = new Date(today); from.setDate(from.getDate() - 29);
    return { from, to: today };
  }
  if (key === "this_month") {
    return { from: new Date(today.getFullYear(), today.getMonth(), 1), to: today };
  }
  if (key === "last_month") {
    const from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const to = new Date(today.getFullYear(), today.getMonth(), 0);
    return { from, to };
  }
  return undefined; // all time
}

const PRESETS = [
  { key: "7", label: "Last 7 days" },
  { key: "30", label: "Last 30 days" },
  { key: "this_month", label: "This month" },
  { key: "last_month", label: "Last month" },
  { key: "all", label: "All time" },
];

export function DateRangePicker({ range, onChange, testid = "date-range" }) {
  const [open, setOpen] = useState(false);
  const label = range?.from
    ? range.to
      ? `${fmt(range.from)} – ${fmt(range.to)}`
      : fmt(range.from)
    : "All dates";

  const pickPreset = (key) => {
    onChange(key === "all" ? undefined : computePreset(key));
    setOpen(false);
  };

  return (
    <div className="flex items-center gap-2">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" data-testid={`${testid}-trigger`}
                  className="gap-2 justify-start font-normal min-w-[240px]">
            <CalendarDays className="h-4 w-4 text-[#0B3D3D]" /> {label}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end" data-testid={`${testid}-popover`}>
          <div className="flex flex-col sm:flex-row">
            <div className="flex sm:flex-col gap-1 p-3 border-b sm:border-b-0 sm:border-r border-border min-w-[150px]">
              {PRESETS.map((p) => (
                <button key={p.key} type="button" data-testid={`${testid}-preset-${p.key}`}
                        onClick={() => pickPreset(p.key)}
                        className="text-left text-sm px-3 py-2 rounded-md hover:bg-[#F0F2F0] text-[#111411] transition-colors whitespace-nowrap">
                  {p.label}
                </button>
              ))}
            </div>
            <Calendar mode="range" selected={range} onSelect={onChange} numberOfMonths={2} defaultMonth={range?.from} />
          </div>
        </PopoverContent>
      </Popover>
      {range?.from && (
        <Button variant="ghost" size="icon" data-testid={`${testid}-clear`} onClick={() => onChange(undefined)}
                className="h-9 w-9 text-muted-foreground">
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
